
import React, { useState, useRef, useEffect } from 'react'
import useClickOutside from '@apex/lib/hooks/useClickOutside'
import Positioner from './Positioner'
import Portal from './Portal'
import Box from './Box'

/**
 * Popover component.
 */

export default function Popover({ content, position, offset, offsetX, offsetY, children }) {
  const [show, setShow] = useState(false)
  const popoverRef = useRef(null)
  const triggerRef = useRef(null)
  let popover

  useClickOutside(popoverRef, _ => setShow(false))
  useResize(_ => setShow(false), [show])

  function onClick(e) {
    e.preventDefault()
    e.stopPropagation()
    setShow(!show)
  }

  if (show) {
    popover = <Portal>
      <Positioner trigger={triggerRef} popover={popoverRef} position={position} offset={offset} offsetX={offsetX} offsetY={offsetY}>{({ style }) => {
        return <StatelessPopover innerRef={popoverRef} style={style}>
          {content({ close: e => setShow(false) })}
        </StatelessPopover>
      }}</Positioner>
    </Portal>
  }

  // check if we have a "native" tag such as 'span', or a Box,
  // this allows event fields to use spans for performance
  const child = typeof children.type == 'string'
    ? React.cloneElement(children, { ref: triggerRef, onClick, active: show })
    : React.cloneElement(children, { innerRef: triggerRef, onClick, active: show }) 

  return <React.Fragment>
    {popover}
    {child}
  </React.Fragment>
}

/**
 * StatelessPopover component.
 */

export function StatelessPopover({ children, ...props }) {
  return <Box className="Popover" {...props}>
    <Box className="content">
      {children}
    </Box>
  </Box>
}

/**
 * Resize hook.
 */

function useResize(cb, deps) {
  useEffect(_ => {
    window.addEventListener('resize', cb)
    return _ => {
      window.removeEventListener('resize', cb)
    }
  }, deps)
}